import api from "../index";

export const ParentDetails = () => api.get(`UserMaster/ParantUserDetail`);